import React from 'react';
import PropTypes from 'prop-types';
import Styles from './styled';
import ButtonLink from '../ButtonLink';
import { useInView } from 'react-intersection-observer';

const PostDownloads = ({ files = [], isAnimated = true, onClick = noop }) => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.25 });

  return (
    <Styles
      ref={ref}
      className={`block-post_downloads ${isAnimated && 'isAnimated'} ${
        inView && 'active'
      }`}
    >
      <div className='inner'>
        {files &&
          files.map(
            ({
              fields: {
                title = '',
                file: { url = '' },
              },
            }) => (
              <ButtonLink
                to={url}
                key={title}
                appearance='dark'
                isExternal
                newTab
                onClick={onClick}
              >
                Download {title}
              </ButtonLink>
            )
          )}
      </div>
    </Styles>
  );
};

PostDownloads.propTypes = {
  files: PropTypes.array,
  isAnimated: PropTypes.bool,
  onClick: PropTypes.func,
};

export default PostDownloads;
